import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import store from "@/store";
import { ENDPOINTS } from "@/services/Endpoints.js";
import dayjs from "dayjs";
import { i18n } from "../../main";
// eslint-disable-next-line no-unused-vars
import _ from "lodash";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
dayjs.extend(customParseFormat);

const {
  LISTAR_PACOTES,
  LISTAR_ITENS_PACOTE,
  LISTAR_STATUS_PEDIDO,
  CADASTRAR_PACOTE,
  DELETAR_PACOTE,
  CADASTRAR_PORTADOR,
  CADASTRAR_PORTADORES,
  FORMAS_DE_PAGAMENTO,
  SEND_ALL_TICKETS,
  SEND_UNIQUE_TICKET_TO_EMAIL,
  SEND_UNIQUE_TICKET_TO_SMS,
  SEND_UNIQUE_TICKET_TO_WHATSAPP,
  CANCELAR_MIDIA,
} = ENDPOINTS;

const { $axios } = Vue.prototype;
const { get, post, delete: del, getLocal, setLocal } = $axios;

Vue.prototype.$ticketPackage = new Vue({
  data() {
    return {
      ENDPOINTS,
      status_pedido: [],
      pacotes_ingressos: [],
      addPackage: false,
      addProduct: false,
      productTab: 0,
      modalSelectStore: false,
      loja_selecionada: "",
      loja_nome: "",
      type: "",
      idpedido: "",
      text: "",
      sendChannel: "EMAIL",
      sendType: "MULTIPLO",
      status: [
        // { text: "Reservado", value: "RE" },
        { text: "Pago", value: "PA" },
      ],
      paymentMethods: [
        { text: "PIX", value: "QRCODE" },
        { text: "Depósito", value: "DEPOSITO" },
      ],
      intervalo_data: [
        { text: "Dia", value: "date" },
        { text: "Semana", value: "week" },
        { text: "Mês", value: "month" },
        { text: "Personalizado", value: "custom" },
      ],
      loading_table: false,
      loading_status: false,
      lista_forma_pagamento: [],
      filter: {
        loja: "",
        consumidor: "",
        email: "",
        celular: "",
        forma_pag: "",
        status: "",
        intervalo_datas: null,
        range_dates: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      cadastro: {
        exp_hor: "",
        exp_dia: "",
        metodo_pagamento: "",
        consumidor: "",
        email: "",
        celular: "",
        cortesia: 1,
        status: "PA",
        desconto: 0,
        itens: [],
      },
      sendPackageInfo: [],
      reservedPackageContentPreview: [],
      packageProductStep: 1,
      packageItem: null,
      packageToSent: [],
      sendLoading: false,
      saveLoading: false,
    };
  },
  computed: {
    dthrExpiraField() {
      if (this.cadastro.exp_dia)
        return `${dayjs(this.cadastro.exp_dia, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        )} ${this.cadastro.exp_hor}`;
      return dayjs().format("YYYY-MM-DD HH:mm");
    },
  },
  methods: {
    isDocumentFormatAndLength(value) {
      return (
        (value.includes(".") && value.includes("-")) ||
        (value.includes(".") && value.includes("/")) ||
        value.length === 8
      );
    },
    documentFormat(value) {
      if (value.length == 10) {
        value = `0${value}`;
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }

      if (value.length == 11) {
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }

      if (value.length == 13 && !value.includes(".")) {
        value = `0${value}`;
        return value.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }

      if (value.length == 14) {
        return value.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }

      return value;
    },
    isPhoneNumberFormatAndLength(value) {
      return (
        (value.length === 14 && value.includes("(")) ||
        (value.length === 13 && !value.includes("("))
      );
    },
    phoneNumberFormat(value) {
      if (value.length === 14) {
        return value.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, "($1) $2 $3-$4");
      }
      return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    },
    getPaymentMethods() {
      get(`${FORMAS_DE_PAGAMENTO}array`).then(response => {
        if (response) {
          const modifiedResponse = response.map(item => {
            if (item.key === "QRCODE" && item.value === "QRCODE") {
              return { key: "PIX", value: "QRCODE" };
            }
            return item;
          });
          this.lista_forma_pagamento = modifiedResponse;
        }
      });
    },
    getOrdersStatus() {
      this.loading_status = true;
      get(`${LISTAR_STATUS_PEDIDO}/array`)
        .then(response => {
          this.status_pedido = response;
          this.loading_status = false;
        })
        .catch(error => {
          this.loading_status = false;
          throw new Error(error);
        });
    },
    getPackageTickets() {
      this.loading_table = true;
      let data = {
        loja: store.getters.storeSequencial,
        status: this.filter.status,
        dthr_pacote_ini: this.filter.range_dates[0]
          ? this.filter.range_dates[0] + " 00:00"
          : "",
        dthr_pacote_fim: this.filter.range_dates[1]
          ? this.filter.range_dates[1] + " 23:59"
          : "",
        nome: this.filter.consumidor,
        metodo_pagamento: this.filter.forma_pag,
      };
      post(LISTAR_PACOTES, data).then(res => {
        this.loading_table = false;
        this.pacotes_ingressos = res;
      });
    },
    async getPackageItems(data) {
      const { idpedido, idconsumidor } = data;
      setLocal("package_info", idpedido);

      const packageData = {
        loja: store.getters.storeSequencial,
        idpedido,
        status: ["PA", "CA"],
        lang: "pt",
        limite: 20,
        pagina: 1,
        pacote: 1,
        idconsumidor,
      };

      post(LISTAR_ITENS_PACOTE, packageData).then(res => {
        this.packageProductStep = 3;
        const itens = res[0]?.itens.map(item => {
          return {
            ...item,
            error: false,
            loading: false,
            sended: false,
          };
        });

        this.packageToSent = itens;

        const productsInOrderBySlug = _.groupBy(itens, "slug_produto");
        const productIdsInOrder = _.keys(productsInOrderBySlug);

        const normalizedOrderProducts = productIdsInOrder.map(productSlug => {
          return this.normalizeProduct(productsInOrderBySlug[productSlug]);
        });

        this.cadastro.itens = normalizedOrderProducts;
        this.reservedPackageContentPreview = normalizedOrderProducts;
      });
    },
    registerValidate() {
      if (this.type == "edit") {
        this.editPackage();
      } else {
        this.registerPackage();
      }
    },
    registerPackage() {
      const {
        metodo_pagamento,
        consumidor: nome,
        email,
        celular,
        cortesia,
        status,
        desconto,
        itens,
      } = this.cadastro;

      if (metodo_pagamento === "" && !cortesia) {
        this.$config.alert(
          i18n.t("sales.payment_method_validation"),
          this.$config.dados.errorColor
        );
        return;
      }

      if (itens.length === 0) {
        this.$config.alert(
          i18n.t("sales.products_to_package_validation"),
          this.$config.dados.errorColor
        );
        return;
      }

      this.packageProductStep = 2;

      let data = {
        loja: store.getters.storeSequencial,
        dthr_expira: this.dthrExpiraField,
        metodo_pagamento,
        nome,
        email,
        celular,
        cortesia,
        status,
        desconto,
        tipo_envio: "MULTIPLO",
        canal_envio: "EMAIL",
        itens,
      };

      post(CADASTRAR_PACOTE, data)
        .then(res => {
          const { idpedido, status, idconsumidor } = res;
          const response = {
            idpedido,
            status,
            idconsumidor,
          };

          this.type = "send";
          this.sendPackageInfo.push(res);
          this.getPackageItems(response);
          this.clearModalPacoteIngresso("cadastro");
        })
        .catch(error => {
          this.packageProductStep = 1;
          throw new Error(error);
        });
    },
    editPackage() {
      let data = {
        loja: store.getters.storeSequencial,
        dthr_expira: this.cadastro.exp_dia
          ? dayjs(this.cadastro.exp_dia, "DD/MM/YYYY").format("YYYY-MM-DD") +
            " " +
            this.cadastro.exp_hor
          : "",
        metodo_pagamento: this.cadastro.metodo_pagamento,
        nome: this.cadastro.consumidor,
        status: this.cadastro.status,
        desconto: this.cadastro.desconto,
        itens: this.cadastro.itens,
      };

      post(CADASTRAR_PACOTE, data)
        .then(() => {
          this.addPackage = false;
          this.getPackageTickets();
          this.clearModalPacoteIngresso("cadastro");
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    async saveAndSendPackage() {
      this.sendLoading = true;
      this.saveLoading = true;
      const { idpedido, idconsumidor } = this.sendPackageInfo[0];
      let hasError = false;
      const itens = this.packageToSent.map(item => {
        const {
          iditem,
          portador_nome: nome,
          portador_doc: doc,
          portador_celular: celular,
          portador_email: email,
          consumidor_email: emailConsumidor,
          consumidor_celular: celularConsumidor,
        } = item;

        return {
          iditem,
          nome,
          doc,
          celular: celular || celularConsumidor,
          email: email || emailConsumidor,
          idconsumidor,
          canal_envio: this.sendChannel,
        };
      });

      if (this.sendType === "MULTIPLO") {
        itens.forEach(item => {
          const { nome, doc, celular, email } = item;
          if (nome === "" || doc === "" || celular === "" || email === "") {
            hasError = true;
            this.$config.alert(
              i18n.t("sales.bearer_fields_validation"),
              this.$config.dados.errorColor
            );
            this.sendLoading = false;
            this.saveLoading = false;
            return;
          }
        });
        if (hasError) {
          return;
        }
      }

      await this.allBearersRegister(this.packageToSent);

      post(SEND_ALL_TICKETS, {
        canal_envio: this.sendChannel,
        tipo_envio: this.sendType,
        idpedido,
        loja: store.getters.storeSequencial,
        idconsumidor,
        idioma: "pt",
        itens,
      }).then(() => {
        this.sendLoading = false;
        this.saveLoading = false;
        this.addPackage = false;
        this.packageProductStep = 1;
        this.sendPackageInfo = [];
        this.clearModalPacoteIngresso("cadastro");
        this.getPackageTickets();
      });
    },
    savePackage() {
      this.allBearersRegister(this.packageToSent);
    },
    sendAPackageItem(type, item) {
      const {
        iditem,
        portador_nome: nome,
        portador_email: email,
        portador_doc: doc,
        portador_celular: celular,
      } = item;

      if (this.sendType === "MULTIPLO") {
        if (nome === "" || email === "" || doc === "" || celular === "") {
          this.$config.alert(
            i18n.t("sales.send_ticket_validation"),
            this.$config.dados.errorColor
          );
          return;
        }
      }

      if (type === "EMAIL") {
        post(`${SEND_UNIQUE_TICKET_TO_EMAIL}${iditem}`, {
          loja: store.getters.storeSequencial,
          idioma: "pt",
        });
        return;
      }

      if (type === "SMS") {
        post(`${SEND_UNIQUE_TICKET_TO_SMS}${iditem}`, {
          loja: store.getters.storeSequencial,
        });
        return;
      }

      if (type === "WHATSAPP") {
        post(`${SEND_UNIQUE_TICKET_TO_WHATSAPP}${iditem}`, {
          loja: store.getters.storeSequencial,
        });
        return;
      }
    },
    bearerRegister(item) {
      item.loading = true;
      let data;
      const {
        iditem,
        portador_nome: nome,
        portador_doc: doc,
        portador_celular: celular,
        portador_email: email,
        consumidor_email: emailConsumidor,
        consumidor_celular: celularConsumidor,
      } = item;

      const { consumidor: idconsumidor } = this.cadastro;
      const { idconsumidor: packageIdConsumidor } = this.sendPackageInfo[0];

      if (this.sendType === "MULTIPLO") {
        if (nome === "" || doc === "" || celular === "" || email === "") {
          this.$config.alert(
            i18n.t("sales.save_carrier_validation"),
            this.$config.dados.errorColor
          );
          item.loading = false;
          return;
        }
        data = {
          loja: store.getters.storeSequencial,
          iditem,
          nome,
          doc,
          celular,
          email,
          idconsumidor: idconsumidor || packageIdConsumidor,
        };
      }

      if (this.sendType === "UNICO") {
        if (nome === "" || doc === "") {
          this.$config.alert(
            i18n.t("sales.save_carrier_validation"),
            this.$config.dados.errorColor
          );
          item.loading = false;
          return;
        }

        data = {
          loja: store.getters.storeSequencial,
          iditem,
          nome,
          doc,
          celular: celularConsumidor,
          email: emailConsumidor,
          idconsumidor: idconsumidor || packageIdConsumidor,
        };
      }

      post(`${CADASTRAR_PORTADOR}${iditem}`, data)
        .then(() => {
          item.loading = false;
          item.sended = true;
        })
        .catch(() => (item.loading = false));
    },
    allBearersRegister(packageStructure) {
      this.saveLoading = true;
      const { data: idpedido } = getLocal("package_info");

      const itens = packageStructure.map(item => {
        const {
          iditem,
          portador_nome: nome,
          portador_doc: doc,
          portador_celular: celular,
          portador_email: email,
          consumidor_email: emailConsumidor,
          consumidor_celular: celularConsumidor,
        } = item;

        return {
          iditem,
          nome,
          doc,
          celular: celular || celularConsumidor,
          email: email || emailConsumidor,
        };
      });

      const sendItens = {
        loja: store.getters.storeSequencial,
        idpedido,
        itens,
      };

      post(CADASTRAR_PORTADORES, sendItens)
        .then(() => {
          this.saveLoading = false;
        })
        .catch(() => {
          this.saveLoading = false;
          throw new Error("Erro ao cadastrar portadores");
        });
    },
    remove(item, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.packageItem = item;
    },
    removePackage(item, msg) {
      this.$config.confirmDialog = true;
      this.text = msg;
      this.idpedido = item;
    },
    cancelPackage() {
      del(
        `${DELETAR_PACOTE}${this.idpedido}?loja=${store.getters.storeSequencial}`
      ).then(() => {
        this.$config.confirmDialog = false;
        this.getPackageTickets();
      });
    },
    removeMidia(item, msg) {
      this.$config.confirmDialog = true;
      this.text = msg;
      this.item = item.iditem;
    },
    cancelMidia() {
      const { idpedido, idconsumidor } = this.sendPackageInfo[0];
      const data = {
        idpedido: idpedido,
        loja: store.getters.storeSequencial,
        idconsumidor: idconsumidor,
      };
      post(`${CANCELAR_MIDIA}${this.item}`, data)
        .then(() => {
          this.$config.confirmDialog = false;
          this.getPackageItems(data);
        })
        .catch(error => {
          console.error(error);
        });
    },

    productFromPackageDelete() {
      this.reservedPackageContentPreview =
        this.reservedPackageContentPreview.filter(
          item => item.idproduto !== this.packageItem.idproduto
        );

      this.cadastro.itens = this.cadastro.itens.filter(
        item => item.idproduto !== this.packageItem.idproduto
      );
    },
    clearFilterFields(field) {
      switch (field) {
        case "pacote_ingresso_dates":
          this.filter.range_dates = [];
          break;
        case "consumidor":
          this.filter.consumidor = "";
          break;
        default:
          break;
      }
    },
    clearModalPacoteIngresso(filtro) {
      switch (filtro) {
        case "filter":
          this.filter.consumidor = "";
          this.filter.forma_pag = "";
          this.filter.email = "";
          this.filter.status = "";
          this.filter.celular = "";
          this.filter.intervalo_data = null;
          this.filter.range_dates = [];
          this.filter.error.range_dates = [];
          this.filter.error.loja = [];
          break;
        case "cadastro":
          this.cadastro.exp_hor = "";
          this.cadastro.exp_dia = "";
          this.cadastro.metodo_pagamento = "";
          this.cadastro.consumidor = "";
          this.cadastro.status = "PA";
          this.cadastro.desconto = 0;
          this.cadastro.email = "";
          this.cadastro.celular = "";
          this.cadastro.itens = [];
          this.type = "send";
          this.packageProductStep = 1;
          this.reservedPackageContentPreview = [];
          break;

        default:
          break;
      }
    },
    normalizeProduct(cartProducts, productInfo = {}) {
      let normalizedProduct = {};

      const hasVariants =
        cartProducts.find(product => product.variacoes) !== undefined;

      if (hasVariants) {
        normalizedProduct = {
          ...productInfo,
          idproduto: cartProducts[0].idproduto,
          date: cartProducts[0].dthr_visitacao || productInfo.data_apresentacao,
          descricao: cartProducts[0].dsc_produto,
          categoria: cartProducts[0].categoria,
          slug: cartProducts[0].slug_produto,
          img: cartProducts[0].img_produto,
          total: cartProducts.reduce(
            (acc, product) => acc + Number(product.valor),
            0
          ),
          quantityIfOnlyQuantity: 0,
          quantityPossibilities: this.getProductItemsByVariation(cartProducts),
        };
        return {
          ...normalizedProduct,
        };
      }

      const quantityIfOnlyQuantity = cartProducts.reduce((acc, product) => {
        const productIndex = acc.findIndex(
          p => p.idproduto === product.idproduto
        );

        if (productIndex === -1) {
          return [...acc, { ...product, quantidade: 1 }];
        }

        acc[productIndex].quantidade++;

        return acc;
      }, []);

      normalizedProduct = {
        ...productInfo,
        idproduto: cartProducts[0].idproduto,
        date: cartProducts[0].dthr_visitacao || productInfo.data_apresentacao,
        descricao: cartProducts[0].dsc_produto,
        slug: cartProducts[0].slug_produto,
        img: cartProducts[0].img_produto,
        total: cartProducts.reduce(
          (acc, product) => acc + Number(product.valor),
          0
        ),
        quantityIfOnlyQuantity: quantityIfOnlyQuantity[0].quantidade,
        quantityPossibilities: 0,
      };

      return normalizedProduct;
    },
    getProductItemsByVariation(product) {
      const groupedVariants = {};

      product.forEach(item => {
        const { dsc_variacao, valor, taxa_conveniencia, idproduto } = item;
        const { idvariacao } = item.variacoes["TEXTO"];

        if (groupedVariants[dsc_variacao]) {
          groupedVariants[dsc_variacao].descricao = dsc_variacao;
          groupedVariants[dsc_variacao].preco = Number(valor);
          groupedVariants[dsc_variacao].taxa_conveniencia =
            Number(taxa_conveniencia);
          groupedVariants[dsc_variacao].idproduto = idproduto;
          groupedVariants[dsc_variacao].idvariacao = idvariacao;
          groupedVariants[dsc_variacao].quantity += 1;
        } else {
          groupedVariants[dsc_variacao] = {
            descricao: dsc_variacao,
            preco: Number(valor),
            taxa_conveniencia: Number(taxa_conveniencia),
            quantity: 1,
            idproduto,
            idvariacao,
          };
        }
      });

      return Object.values(groupedVariants);
    },
  },
});
